module.exports = __webpack_public_path__ + "static/media/ic_check_single.803eb835.svg";